import {SelectBox} from "devextreme-react";
import React, {useEffect} from "react";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import {useFormContext} from "react-hook-form";
import "./NewForms.css";

interface IProps {
    title?: string;
    fieldName: string;
    items: any[];
    showBorder?: boolean;
    required?: boolean;
    width?: number;
    index?: number;
    onValueChange?: any;
    placeholder?: string;
}

export const NFLookupInput = ({
                                  title,
                                  fieldName,
                                  items,
                                  width,
                                  showBorder,
                                  index,
                                  onValueChange,
                                  placeholder,
                              }: IProps) => {
    const [dataSource, setDataSource] = React.useState<DataSource | undefined>(
        undefined
    );
    const [currentValue, setCurrentValue] = React.useState<any>(undefined);
    const {getValues, setValue} = useFormContext();

    const store = new CustomStore<any, string>({
        key: "id",
        load: (loadOptions) => {
            return items;
        },
        byKey: (key) => {
            return items.find((x) => x.id === key);
        },
    });

    useEffect(() => {
        const newDataSource = new DataSource({
            store: store,
            paginate: true,
            pageSize: 15,
        });
        setDataSource(newDataSource);
    }, [items]);

    useEffect(() => {
        setCurrentValue(getValues(fieldName));
    }, [getValues(fieldName)]);

    const handleChangedValue = (newValue?: any) => {
        setValue(fieldName, newValue);
        setCurrentValue(newValue);
        if (onValueChange) {
            onValueChange(newValue, index);
        }
    };

    return (
        <div className={title ? "form-group" : ""}>
            {title && <label className={"form-label-sm"}>{title}</label>}
            <SelectBox
                dataSource={dataSource}
                className="bg-light"
                style={{
                    border: !showBorder ? "block" : showBorder ? "block" : "none",
                }}
                width={width || undefined}
                displayExpr={"name"}
                valueExpr={"id"}
                value={currentValue}
                onValueChanged={(e) => handleChangedValue(e.value)}
                placeholder={placeholder}
            />
        </div>
    );
};
